import { useMemo } from "react";
import ContextMenu, { Position } from "devextreme-react/context-menu";
import List from "devextreme-react/list";
import "./user-panel.scss";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from "../../services/urls";
import { useHistory } from "react-router";
import auth, { userSelector } from "../../redux/auth";

export default function UserPanel({
  menuMode,
}: {
  menuMode: "context" | "list";
}) {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const history = useHistory();

  function navigateToProfile() {
    history.push("/profile");
  }
  const menuItems = useMemo(
    () => [
      {
        text: "Profile",
        icon: "user",
        onClick: navigateToProfile,
      },
      {
        text: "Logout",
        icon: "runner",
        onClick: () => dispatch(auth.actions.logoutAction()),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [auth.actions.logoutAction]
  );

  return (
    <div className={"user-panel"}>
      <div className={"user-info"}>
        <div className={"image-container"}>
          <div
            style={{
              background: `url(${user?.ProfileImage}) no-repeat #fff`,
              backgroundSize: "cover",
            }}
            className={"user-image"}
          />
          <img
            className={"user-image"}
            src={baseUrl + user?.ProfileImage}
            alt=""
          />
        </div>
        <div className={"user-name"}>{user?.Name}</div>
      </div>

      {menuMode === "context" && (
        <ContextMenu
          items={menuItems}
          target={".user-button"}
          showEvent={"dxclick"}
          cssClass={"user-menu"}
        >
          <Position my={"top center"} at={"bottom center"} />
        </ContextMenu>
      )}
      {menuMode === "list" && (
        <List className={"dx-toolbar-menu-action"} items={menuItems} />
      )}
    </div>
  );
}
